import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./_newsletter.scss";
import NewsletterForm from "./form";

class NewsLetter extends Component {
  render() {
    return (
      <section
        id="news-letter-section"
        style={{
          background: "var(--cardBg)",
          boxShadow: "var(--boxShadow)"
        }}
        className="container-size"
      >
        <div className="row m-0 pl-2 pr-2">
          <div className="col-md-6 news-letter-text">
            <span>
              <FontAwesomeIcon icon={faEnvelope} className="faEnvelope mr-2" />
              Tau support and newsletter
            </span>
            <h2 className="mt-2" style={{ color: "var(--h2Color)" }}>
              Keep upwith latest Development updates
            </h2>
          </div>

          <div className="col-md-6 news-letter-form">
            <NewsletterForm />
          </div>
        </div>
      </section>
    );
  }
}

export default NewsLetter;
